import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GripLocation } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class GripLocationsService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  getLocations(municipalityId: number) {
    return this.http.get<GripLocation[]>(`${this.BASE_URL}api/my-rova/notifications/grip/Locations?municipalityId=${municipalityId}`);
  }

  getNearestLocation(postalCode: string, houseNumber: number, addition: string = '', token: string = '') {
    return this.http.get<GripLocation>(
      `${this.BASE_URL}api/my-rova/grip/location?postalCode=${postalCode}&housenumber=${houseNumber}&addition=${
        addition || ''
      }&token=${token}`
    );
  }
}
